export const awsConfiguration: {
	region: string;
	host: string;
	apiVersion: string;
	machineMode: boolean;
	apiKey: string;
	mapBoxApiKey: string;
	esriApiKey: string;
	restApiId: string;
} = {
	region: "us-east-1",
	host: "a8m0fg7yvuu5k-ats.iot.us-east-1.amazonaws.com", // 'YourAwsIoTEndpoint', e.g. 'prefix.iot.us-east-1.amazonaws.com'
	apiVersion: "Beta",
	machineMode: false,
	apiKey: "AIzaSyDa6ZFf53TRQWAUad0vTl-2HZ5Hn82pf2c",
	mapBoxApiKey:
		"sk.eyJ1IjoicHJhbnlzYSIsImEiOiJja3U2MmNhNGkxcHBpMnFuaWg5OTQ0ZGh4In0.TdPCb8ZOXG_XDUWE8Rwe0g",
	esriApiKey:
		"AAPK83d1d9964a9243e6a59bac3a6119bf47VaVA5uW-nqqXZsxDWiyy1j7yWd2UwCpXlKbmSYWdo942RQ2QZvHMGccPVEwWUbOQ",
	restApiId: "uej1di59a8",
};

export const apiEndpoint =
	"https://uej1di59a8.execute-api.us-east-1.amazonaws.com";

export const getApiUrl = (apiVersion: string) => `${apiEndpoint}/${apiVersion}`;
